import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { RoutesPaths } from "../../Router/constant";
import { backendUrl } from "../../constants";

const CampaignScroller = ({ allCampaigns, getTimeAgo }) => {
    const scrollRef = useRef(null);
    const navigate = useNavigate();

    const scroll = (direction) => {
        const container = scrollRef.current;
        const scrollAmount = 320;

        container.scrollBy({
            left: direction === "left" ? -scrollAmount : scrollAmount,
            behavior: "smooth",
        });
    };

    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(true);

    const checkScroll = () => {
        const el = scrollRef.current;
        setCanScrollLeft(el.scrollLeft > 0);
        setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth);
    };

    useEffect(() => {
        checkScroll();
        const el = scrollRef.current;
        el.addEventListener("scroll", checkScroll);
        return () => el.removeEventListener("scroll", checkScroll);
    }, []);

    return (
        <div className="recommended-box">
            <h3>Campaigns</h3>

            <div className="scroll-wrapper">
                {/* LEFT ARROW */}
                {canScrollLeft &&
                    <button
                        className="scroll-btn left"
                        onClick={() => scroll("left")}
                    >
                        ‹
                    </button>
                }

                {/* SCROLL CONTAINER */}
                <div className="campaign-scroll" ref={scrollRef}>
                    {allCampaigns?.map((item) => (
                        <div
                            key={item.id}
                            className="campaign-card"
                            onClick={() =>
                                navigate(
                                    RoutesPaths.PEOPLE_AI_BASE.replace(
                                        ":id",
                                        item?.slug ? item?.slug : item?.id
                                    )
                                )
                            }
                        >
                            <img
                                src={
                                    item?.images?.length > 0
                                        ? backendUrl + item?.images[0].filename
                                        : "/assets/img/peopleAi.png"
                                }
                                alt="campaign"
                                className="campaign-img"
                                onError={(e) => {
                                    e.currentTarget.onerror = null; // prevent infinite loop
                                    e.currentTarget.src = "/assets/img/peopleAi.png";
                                }}
                            />

                            <div className="card-content">
                                <p className="username">{item.user}</p>
                                <p className="recommended-boxTxt">{item.description}</p>

                                <div className="likeViewClass">
                                    <span></span>
                                    <div className="hoursAgoClass">
                                        <p
                                            className="user-level mb-1"
                                        >
                                            POSTED
                                        </p>
                                        <p className="posted">
                                            {getTimeAgo(item?.createdAt)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))?.reverse()}
                </div>

                {/* RIGHT ARROW */}
                {canScrollRight &&
                    <button
                        disabled={!canScrollRight}
                        className="scroll-btn right"
                        onClick={() => scroll("right")}
                    >
                        ›
                    </button>
                }
            </div>
        </div>
    );
};

export default CampaignScroller;